/* eslint-disable */
import { AxiosInstance, AxiosResponse } from 'axios'
import { Exactly } from './utils'

export type OperationWithAxiosResponse = <T extends Exactly<Request, T>>(request: T) => Promise<AxiosResponse<Response>>
export const operationWithAxiosResponse = <T extends Exactly<Request, T>>(axios: AxiosInstance, request: T): Promise<AxiosResponse<Response>> => {
  return axios.request({
    url: `/authenticate`,
    // @ts-ignore for sm-axios
    urlTemplate: '/authenticate',
    method: 'POST',
    headers: request.headers,
    data: request.body,
  })
}

/**
 * exchange auth code for validation
 */
export type Operation = <T extends Exactly<Request, T>>(request: T) => Promise<Response>
export const operation = async <T extends Exactly<Request, T>>(axios: AxiosInstance, request: T): Promise<Response> => {
  return (await operationWithAxiosResponse(axios, request)).data
}

export interface Request {
  headers?: {
    'x-sm-mobile-app-device-id'?: string
    redirecturi?: string
  }
  body: {
    code: string
    redirectUri: string
    tenantCode: string
    userDeviceToken?: string | null
    state?: string | null
    deviceId?: string | null
    /**
     * set when the user has explicitly requested to set up MFA even though they are not currently MFA-required
     */
    temporaryMfaSetup?: boolean
    [k: string]: any
  }
}

export type Response = {
  partnerCode?: string
  provider?: 'auth0' | 'authx'
  uuid: string
  email: string
  state:
    | 'AUTHENTICATED'
    | 'PASSWORD_EXPIRED'
    | 'MFA_VERIFICATION_REQUIRED'
    | 'MFA_REGISTRATION_REQUIRED'
    | 'MFA_REGISTRATION_RECOMMENDED'
    | 'MFA_REGISTRATION_OPTIONAL'
    | 'TRUSTED_DEVICE_VERIFICATION_REQUIRED'
  defaultRedirectUri: string
  passwordExpiryInDays: number
  passwordChangeWarningInDays: number
  /**
   * signed token by login-beef that contains email and provider to be stored by frontend for later during logout or partner /generate_token operations
   */
  token: string
  /**
   * num days left for mfa setup
   */
  mfaRequiredByRemainingInDays?: number
  /**
   * user type
   */
  type: 'staff' | 'property' | 'enterprise' | 'partner'
  emailVerificationRequired: boolean
  /**
   * The language code chosen by the user
   */
  locale: 'en' | 'en-gb' | 'fr' | 'de' | 'it' | 'pt' | 'es' | 'th' | 'id'
  trustedDevice?: {
    deviceId: string
  } | null
} & (
  | {}
  | {
      mfaRegistrationType: 'totp' | 'smmobile'
      passkeys?: {
        email: string
        id: string
      }[]
    }
)

